// Editorial Blog Grid - Scroll Animations and Interactions

document.addEventListener('DOMContentLoaded', function() {
  
  // Intersection Observer for scroll animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1
  };

  const articleObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Observe all article cards
  const articleCards = document.querySelectorAll('[data-article-card]');
  articleCards.forEach(card => {
    articleObserver.observe(card);
  });

  // Observe featured article
  const featuredArticle = document.querySelector('[data-article-featured]');
  if (featuredArticle) {
    articleObserver.observe(featuredArticle);
  }

  // Parallax effect on featured article image
  if (featuredArticle) {
    const featuredImage = featuredArticle.querySelector('.editorial-featured-article__image img');
    
    if (featuredImage) {
      window.addEventListener('scroll', () => {
        const scrolled = window.scrollY;
        const rate = scrolled * 0.3;
        
        if (featuredImage && scrolled < window.innerHeight) {
          featuredImage.style.transform = `translateY(${rate}px) scale(1.1)`;
        }
      }, { passive: true });
    }
  }

  // Hover effect enhancement for article cards
  articleCards.forEach(card => {
    const link = card.querySelector('.editorial-article-card__link');
    const image = card.querySelector('.editorial-article-card__image img');
    
    if (link && image) {
      link.addEventListener('mouseenter', () => {
        image.style.transform = 'scale(1.08)';
      });
      
      link.addEventListener('mouseleave', () => {
        image.style.transform = 'scale(1)';
      });
    }
  });

  // Read time calculation enhancement
  const calculateReadTime = (content) => {
    const wordsPerMinute = 200;
    const words = content.trim().split(/\s+/).length;
    const readTime = Math.ceil(words / wordsPerMinute);
    return readTime;
  };

  // Smooth scroll for pagination
  const paginationLinks = document.querySelectorAll('.editorial-pagination__link, .editorial-pagination__number');
  paginationLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });

});
